import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AccountingAPIService } from 'app/api/accounting.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import { sortBy } from 'lodash';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
    AccountingActions,
    AccountingActionTypes,
    AccountingCancelled,
    AccountingLoaded,
    AccountingRequested
} from './accounting.actions';

@Injectable()
export class AccountingEffects {
    @Effect()
    loadAccounting$ = this.actions$.pipe(
        ofType<AccountingRequested>(AccountingActionTypes.AccountingRequested),
        mergeMap(action => {
            // tslint:disable-next-line: no-shadowed-variable
            const { companyId, key, filter } = action.payload;
            return this.accountingApiService
                .Accounting(companyId, key, filter)
                .pipe(
                    map(
                        items =>
                            new AccountingLoaded({
                                accounting: sortBy(items, 'key')
                            })
                    ),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new AccountingCancelled({ errorMessage }));
                    })
                );
        })
    );

    constructor(
        private actions$: Actions<AccountingActions>,
        private store: Store<AppState>,
        private accountingApiService: AccountingAPIService
    ) {}
}
